import { Children, cloneElement, isValidElement, useState } from "react";

import { RadioCardContainer } from "./RadioCard.styles";
import { RadioCardItem, type RadioCardItemProps } from "./RadioCardItem";

type RadioCardGroupProps = {
  children: React.ReactNode;
  defaultValue: string;
  onValueChange?: (value: string) => void;
  editable?: boolean;
};

export const RadioCardGroup = ({
  children,
  defaultValue,
  onValueChange,
  editable,
}: RadioCardGroupProps) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue);

  return (
    <RadioCardContainer role="radiogroup">
      {Children.map(children, (child) => {
        if (!child || !isValidElement<RadioCardItemProps>(child)) {
          return child;
        }
        if (
          typeof child.type !== "string" &&
          "name" in child.type &&
          child.type.name &&
          child.type.name !== RadioCardItem.name
        ) {
          return child;
        }
        return cloneElement(child, {
          selected: child.props.selected ?? selectedValue === child.props.value,
          editable: editable,
          onClick: () => {
            if (!editable) {
              return;
            }
            setSelectedValue(child.props.value);
            onValueChange?.(child.props.value);
          },
        });
      })}
    </RadioCardContainer>
  );
};
